(function($) {

var pageId = 'page-documentdirs',
    page = '#' + pageId;

$(document).on('pjaxload#' + pageId, function(e, $page, page) {
    tower.initDocViews();
    tower.initDocDnD($page);
});

$(function() {
    $(document).on('click', page + ' .detail-action-edit', function(e) {
        e.preventDefault();
        $('.crumb .current-doc-dir').trigger('click');

    }).on('click', page + ' .crumb .current-doc-dir', function(e) {
        var $name = $(this).hide();
        var $btnGroup = $name.closest('.crumb').siblings('tr-new-doc-menu').hide();
        $btnGroup.siblings('.rename-doc-dir').show()
            .find('#txt-doc-dir-name')
            .val($name.text())
            .focus()
            .select();
    }).on('click', page + ' #link-cancel-rename', function(e) {
        var $link = $(this);
        var $rename = $(this).closest('.rename-doc-dir').hide();
        $rename.siblings('tr-new-doc-menu').show();
        $rename.siblings('.crumb').find('.current-doc-dir').show();
    }).on('keydown', page + ' #txt-doc-dir-name', function(e) {
        if (e.which == 27) {
            $(page).find('#link-cancel-rename').trigger('click');
            return false;
        } else if (e.which == 13) {
            $(page).find('#btn-rename-doc-dir').trigger('click');
            return false;
        }
    }).on('ajax:success', page + ' .rename-doc-dir form', function(e) {
        var name = $('#txt-doc-dir-name').val();
        $(page).find('.crumb .current-doc-dir').show().text(name);
        $(page).find('.rename-doc-dir').hide()
            .siblings('tr-new-doc-menu').show();
    });
});

})(jQuery);
